export default __webpack_public_path__ + "static/media/report.8fd68a8d.svg";